// extracted by mini-css-extract-plugin
export var Accordion = "Accordion-module--Accordion--WWx9J";
export var Indicator = "Accordion-module--Indicator--3eV2u";